import { STOP_LOADING, START_LOADING } from '../types/loading'

const initState = {
  loading: false,
  loadingCount: 0,
}

const loadingReducer = (state = initState, action = {}) => {
  switch (action.type) {
    case START_LOADING: {
      const loadingCount = state.loadingCount + 1
      return { loadingCount, loading: true }
    }
    case STOP_LOADING: {
      const loadingCount = Math.max(0, state.loadingCount - 1)
      return { loadingCount, loading: loadingCount > 0 }
    }
    default:
      return state
  }
}

export default loadingReducer



// WEBPACK FOOTER //
// ./src/reducers/loading.js